<template>
  <div class="card">
    <el-row :gutter="40">
      <el-col :span="6">
        <div class="card-body" ref="searchBox">
          <div class="d-flex with-button">
            <div class="p-2">
              <h1>문제 그룹</h1>
            </div>
            <div class="p-2 small bottom">
              총 <strong><span class="number mint">{{groupTableData.length}}</span></strong> 건
            </div>
          </div>

          <div class="d-flex">
            <div class="p-2 w-100">
              <div class="input-group search">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="searchGroup.title" @keyup.enter="retrieveGroup" placeholder="문제그룹">
                <div class="input-group-apend">
                  <button type="button" class="btn btn-default" @click="retrieveGroup">
                     검색
                  </button>
                </div>
              </div>
            </div>
            <div class="p-2 search-detail" v-if="searchDetailVisible">
              <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
            </div>
          </div>

        </div>

        <!-- <div class="grid-top-header" ref="filterBox">
           <el-button class="excel" :loading="excelLoading" @click="downloadExcel"><i class="fas fa-file-excel"></i></el-button>
        </div> -->

        <stone-data-table
          ref="groupDataTable"
          table-ref="groupDataTable"
          :loading="groupSearchLoading"
          :columns="groupTableColumns"
          :data="groupTableData"
          :table-props="groupTableProps"
          :pagination-props="groupPaginationProps"
          :current-page="stoneDataTableCurrentPage"
          :action-col="groupActionCol"
          :current-row="currentRow"
          @current-page-change="handlerStoneDataTableCurrentPageChange"
          @row-click="groupRowClickHandler">
        </stone-data-table>
      </el-col>

      <el-col :span="18">
        <div class="card-body" ref="searchBox">
          <div class="d-flex with-button">
            <div class="p-2">
              <h1>문제</h1>
            </div>
            <div class="p-2 small bottom">
              총 <strong><span class="number mint">{{quizTableTotal}}</span></strong> 건
            </div>
            <div class="ml-auto p-2">
              <excel :name="btnExcelName" @click="downloadExcel" :loading="excelLoading"></excel>
            </div>
          </div>

          <div class="d-flex">
            <div class="p-2 w-100">
              <div class="input-group search">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <input type="text" class="form-control" aria-describedby="basic-addon1" v-model.trim="searchQuiz.search_text" @keyup.enter="retrieveQuiz(0)" placeholder="문제그룹 / 구분 / 문제내용">
                <div class="input-group-apend">
                  <button type="button" class="btn btn-default" @click="retrieveQuiz(0)">
                     검색
                  </button>
                </div>
              </div>
            </div>
            <div class="p-2 search-detail" v-if="searchDetailVisible">
              <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
            </div>
          </div>

        </div>

        <!-- <div class="grid-top-header" ref="filterBox">
           <el-button class="excel" :loading="excelLoading" @click="downloadExcel"><i class="fas fa-file-excel"></i></el-button>
        </div> -->

        <stone-data-table-server
          ref="dataTableServer"
          table-ref="dataTableServer"
          :loading="searchLoading"
          :columns="quizTableColumns"
          :data="quizTableData"
          :table-props="defaultTableProps"
          :pagination-props="quizPaginationProps"
          :page-size="quizPageSize"
          @query-change="quizTableLoadData"
          @row-click="quizRowClickHandler">
        </stone-data-table-server>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M030103',
  mixins: [common.mixins],
  data () {
    return {
      groupTableData: [],
      groupTableColumns: [
        {label: 'No', type: 'index', align: 'left', width: 80, sortable: false, class: 'no-point', index: this.indexHandler},
        {label: '문제 그룹', prop: 'title', align: 'left', width: 150, class: 'no-point'}
        // {label: '생성자', prop: 'reg_user_name', align: 'left', width: 100},
        // {label: '생성일', prop: 'reg_dt', align: 'center', formatter: this.columnFormatterDate, width: 100, dataType: 'date', format: 'yyyy.MM.dd'}
      ],
      groupTableProps: {height: this.getScreenHeight(), highlightCurrentRow: true},
      groupPaginationProps: {layout: 'pager', pagerCount: 5},
      groupSearchLoading: false,
      groupActionCol: {
        label: '원본',
        props: {
          align: 'center',
          width: 80
        },
        buttons: [{
          handler: row => {
            if (this.$store.getters.user_type === 'A') {
              this.downloadFile(row.download_url)
            } else {
              this.$message.warning('괸리자만 다운로드 가능합니다.')
            }
          },
          props: {
            icon: 'el-icon-download',
            popover: this.$refs.popover5
          }
        }]
      },
      quizTableData: [],
      quizTableColumns: [
        {label: 'No', prop: 'rnum', align: 'left', width: 80, sortable: false, type: 'row_number'},
        {label: '분류', prop: 'quiz_type_name', align: 'center', width: 100},
        {label: '문제그룹', prop: 'quiz_grp_title', align: 'left', width: 150},
        {label: '구분', prop: 'tag', align: 'left', width: 90},
        {label: '문제내용', prop: 'title', align: 'left', width: 300, tooltip: false},
        {label: '정답률', prop: 'quiz_correct_rate', align: 'right', formatter: this.columnFormatterRate, width: 100, dataType: 'percentage', format: '0.0%'},
        {label: '생성자', prop: 'reg_user_name', align: 'left', width: 100},
        {label: '생성일', prop: 'reg_dt', align: 'center', formatter: this.columnFormatterDate, width: 100, dataType: 'date', format: 'yyyy.MM.dd'}
      ],
      quizPaginationProps: {pageSizes: [10]},
      quizTableTotal: 0,
      quizPageSize: 10,
      searchGroup: {
        search_text: '',
        title: ''
      },
      searchQuiz: {
        search_text: '',
        content: '',
        quiz_grp_seq: 0
      },
      isFirst: true,
      currentRow: null
    }
  },
  created () {
    this.retrieveGroup(true)
  },
  mounted () {
  },
  methods: {
    retrieveGroup (isInit = false) {
      this.groupSearchLoading = true
      this.quizTableData = []
      this.quizTableTotal = 0
      this.currentRow = null
      common.axios.post('/group/file/list', this.searchGroup)
        .then(response => {
          this.groupSearchLoading = false
          this.groupTableData = response.data
          // console.log('response.data : ', response.data)
          // console.log('this.$route.params.quiz : ', this.$route.params.quiz)
          if (isInit && this.$route.params.quiz) {
            // 문제 그룹 선택
            const oldGroupRow = this.groupTableData.find(x => x.grp_seq === this.$route.params.quiz.search.quiz_grp_seq)
            // console.log('oldGroupRow : ', oldGroupRow)
            this.currentRow = oldGroupRow
            this.$nextTick(() => {
              this.searchQuiz = this.$route.params.quiz.search
              const queryInfo = this.$route.params.quiz.query
              // console.log('queryInfo : ', queryInfo)
              // console.log(this.$refs.dataTableServer.$refs.dataTableServer.$refs.elTable.sort)
              if (queryInfo.sort.prop) {
                const dataTables = this.getDataTable('dataTableServer')
                dataTables.sort(queryInfo.sort.prop, queryInfo.sort.order)
                this.isCurrentPage = true
              } else {
                this.quizTableLoadData(queryInfo, true)
              }
            })
            // localStorage page_params를 삭제한다.
            this.$store.dispatch('PAGE_PARAMS_DELETE')
          }
        })
        .catch(() => {
          this.groupSearchLoading = false
        })
    },
    retrieveQuiz (grpSeq = 0) {
      // this.clearDataTableSort('dataTableServer')
      if (!this.isEmptySeq(grpSeq)) {
        this.searchQuiz.quiz_grp_seq = grpSeq
      } else {
        this.clearDataTableCurrentRow('groupDataTable')
        this.currentRow = null
        this.searchQuiz.quiz_grp_seq = 0
      }
      // this.searchQuiz.quiz_grp_seq = !this.isEmptySeq(grpSeq) ? grpSeq : 0
      this.$nextTick(() => {
        this.clearDataTableSort('dataTableServer')
        this.quizTableData = []
        // this.$refs.dataTableServer.localCurrentPage = 1
        this.$nextTick(() => {
          const queryInfo = {page: 1, pageSize: this.quizPageSize, type: 'init', filters: [], sort: {}}
          this.quizTableLoadData(queryInfo)
        })
      })
    },
    goEdit (quizSeq) {
      const param = {
        quiz_seq: quizSeq,
        quiz: this.quizParam,
        page: 'M030103'
      }
      this.$store.dispatch('PAGE_PARAMS_REGISTER', param)
        .then(() => {
          this.$router.push({name: 'M030102', params: param})
        })
        .catch(() => {
          console.error('PAGE_PARAMS_REGISTER Error')
        })
    },
    groupRowClickHandler (row, event, column) {
      if (column.label !== ' ') {
        this.currentRow = row
        this.searchQuiz = {search_text: '', content: '', quiz_grp_seq: 0}
        this.retrieveQuiz(row.grp_seq)
      } else {
        if (this.quizTableData.length === 0) {
          this.clearDataTableCurrentRow('groupDataTable')
          this.searchQuiz.quiz_grp_seq = 0
        }
      }
    },
    quizRowClickHandler (row) {
      this.goEdit(row.quiz_seq)
    },
    async quizTableLoadData (queryInfo, isClear = false) {
      if (this.isFirst) {
        this.isFirst = false
        return
      }
      const param = Object.assign({query: queryInfo}, this.searchQuiz)
      this.quizParam = {query: queryInfo, search: this.searchQuiz}
      // console.log('queryInfo : ', this.quizParam)
      // console.log('param : ', param)
      this.loadStoneDataTable('/quiz/list', param, true, false)
        .then(response => {
          this.quizTableData = response.data
          this.quizTableTotal = this.quizTableData && this.quizTableData.length > 0 ? this.quizTableData[0].total_count : 0
          if ((this.isCurrentPage || isClear) && this.$route.params.quiz) {
            this.$refs.dataTableServer.localCurrentPage = this.$route.params.quiz.query.page
            if (this.isCurrentPage) {
              this.isCurrentPage = false
            }
            this.$route.params.quiz = null
            // const dataTables = this.getDataTable('dataTableServer')
            // dataTables.sort(queryInfo.sort.prop, queryInfo.sort.order)
            // this.$route.params.quiz = null
          }
        })
    },
    downloadExcel () {
      // console.log('currentRow : ', this.currentRow)
      const param = {
        data: {
          service: 'QuizService',
          method: 'getQuizList',
          params: this.searchQuiz
        },
        excel: {
          columns: this.quizTableColumns,
          file: this.currentRow ? this.currentRow.title : ''
        }
      }
      this.exportExcel(param)
    },
    onPopStateEventHandler () {
      if (this.$store.getters.page_params.quiz) {
        this.$route.params.quiz = this.$store.getters.page_params.quiz
        // this.retrieveGroup(true)
      }
    },
    indexHandler (index) {
      return ((this.stoneDataTableCurrentPage - 1) * 20) + (index + 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M030103.vue